import getValueByDotNotation from './getValueByDotNotation';
import hasAtLeastOneValue from './hasAtLeastOneValue';

const applyWriteOnce = (permission, field) => {
  if (permission === 'WRITE_ONCE') {
    if (field?.initialValue && hasAtLeastOneValue(field.initialValue)) {
      return 'READ';
    }
    return 'WRITE';
  }
  return permission;
};

const getFieldPermission = ({ field, permissions }) => {
  if (field?.permission) {
    return field?.permission;
  }

  if (field?.permissionName) {
    const permissionValue = getValueByDotNotation(
      permissions,
      field?.permissionName,
    );
    return permissionValue;
  }

  const permissionCandidates = [
    permissions?.[field.name],
    getValueByDotNotation(permissions, field.name),
  ];

  if (field?.name?.includes('.')) {
    permissionCandidates.push(permissions?.[field.name.split('.')[0]]);
  }

  const matchedPermission = permissionCandidates.find(Boolean);
  if (matchedPermission) {
    return applyWriteOnce(matchedPermission, field);
  }

  // static permissions for special form components
  if (field?.control === 'subsection') {
    return 'READ_ONLY';
  }

  // if permission is not found but has no name attribute(like pagesections)
  if (!field?.name) {
    return 'READ_ONLY';
  }

  // Fields that have names but no permissions
  return 'NO_PERMISSION';
};

export default getFieldPermission;
